"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAutocomplete = void 0;
const StyledAutocomplete = (readOnly) => {
    return {
        "input[read-only]": {
            border: "none !important",
            backgroundColor: "transparent !important",
        },
        input: {
            fontSize: readOnly ? "14px" : "16px",
        },
        backgroundColor: readOnly ? "transparent !important" : "",
        fieldset: {
            border: readOnly ? "none !important" : "",
        },
    };
};
exports.StyledAutocomplete = StyledAutocomplete;
